var map = {
	"./api.svg": 1985,
	"./apps.svg": 1986,
	"./arrow-left-line.svg": 988,
	"./arrow-right-line.svg": 989,
	"./bell.svg": 990,
	"./chart-line.svg": 1987,
	"./chat-bubble-question.svg": 1988,
	"./chevron-down.svg": 991,
	"./clapper.svg": 1989,
	"./clock.svg": 1990,
	"./cog.svg": 1991,
	"./controller.svg": 1992,
	"./download.svg": 992,
	"./export.svg": 993,
	"./folder-open.svg": 1993,
	"./inbox.svg": 1994,
	"./key.svg": 1995,
	"./lightning-bolt.svg": 1996,
	"./lock.svg": 1997,
	"./megaphone.svg": 1998,
	"./message.svg": 1999,
	"./messages.svg": 2000,
	"./restore-page.svg": 2001,
	"./rotate-auto.svg": 2002,
	"./search-insights.svg": 2003,
	"./smiley.svg": 2004,
	"./tag.svg": 2005,
	"./user-card.svg": 2006,
	"./user-group.svg": 2007,
	"./user.svg": 2008,
	"./whatsapp.svg": 2009,
	"./work.svg": 2010,
	"./workflow.svg": 2011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1089;